import { TOLERANCE_APPROVAL, PIT_INVOICE_ISSUE, FETCH_WORKLIST, ISSUE_ATC_ATC, INSPECTION_ORDER_GRAPH, DOWNLOAD_DOCUMENT, UPLOAD_DCUMENT, FETCH_MATERIAL_CODE, FETCH_INSPECTION_FOR, FETCH_GRIEVANCE_NO, FETCH_INSPECTIONWORK_ORDER_LIST, FETCH_ISSUE_NO, FETCH_PIT_INVENTORY_DETAILS, FETCH_MANAGE_TOLERANCE_LIST, ADD_MANAGE_TOLERANCE_LIST, DELETE_MANAGE_TOLERANCE_LIST, FETCH_MANAGE_TOLERANCE_LIST_BY_ID, EDIT_MANAGE_TOLERANCE_LIST, GET_ISSUE_LIST, UPDATE_ISSUE_BY_ID, FETCH_INSPECTOR_LIST, FETCH_QUALITY_PARAMETER_LIST, FETCH_EQUIPMENT_LIST, ADD_CREATE_INSPECTION, FETCH_ISSUE_FROM_ISSUE_NUMBER, FETCH_INSPECTION_DETAILS_BY_ID, EDIT_INSPECTION_DETAILS_BY_ID, FETCH_INSPECTION_BY_ID, UPDATE_CONDUCT_INSPECTION_SUBMIT, FETCH_STATUS_DROPDOWN, FETCH_QUALITY_PARAMETER_DROPDOWN, FETCH_BY_INSPECTION_CATEGORY, UPDATE_WORKLOG, CREATE_ISSUE, FETCH_PARA_TOLERANCE_LIMIT, FETCH_WORKLOG, GET_ISPECTOR_DETAILS, INSPECTION_FETCH_PITDETAILS, INSPECTION_FETCH_BUNDLEID_DETAILS, BUNDLES_BY_CON } from "../../common/URLs";

import { toast } from 'react-toastify';
import { loaderService } from "../../common/custom-loader/loader-service";
import { getLocalStorageItem } from "../../common/localStorageUtils";
import { authKey } from '../../common/URLs';
import { bundleArr } from '../../common/constants';
import apiClient from "../../axios";

export function getqualitymaterialcode(setAllMaterialCode) {
  apiClient
    .post(FETCH_MATERIAL_CODE,
      {},
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      setAllMaterialCode(response.data);
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
    });
}

export function getqualityinspection(setAllInspectionDetails) {
  apiClient
    .post(FETCH_INSPECTION_FOR,
      {

      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      setAllInspectionDetails(response.data);
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);

    });
}

export function getgrievancedetails(setAllGrievanceDetails) {
  apiClient
    .post(FETCH_GRIEVANCE_NO,
      {

      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      setAllGrievanceDetails(response.data?.qualityGrievancePojo);
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);

    });
}

export function getInspectionWorkOrderList(setAllInspectionWorkList) {
  loaderService.showLoader();
  apiClient
    .post(FETCH_INSPECTIONWORK_ORDER_LIST,
      {

      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      setAllInspectionWorkList(response.data);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();

    });
}

export function getIssueNo(setAllIssueDetails) {
  apiClient
    .post(FETCH_ISSUE_NO,
      {

      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      setAllIssueDetails(response.data);
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);

    });
}

// export function getpitinventorydetails(inspectionFor, materialCode, setPitInventoryDetails, setLoading, setTempArrPit) {
//   setLoading(true)
//   apiClient
//     .post(FETCH_PIT_INVENTORY_DETAILS,
//       {
//         "materialCode": materialCode,
//         "stakeholderType": inspectionFor
//       },
//       {
//         headers: {
//           Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
//         }
//       }, null
//     )
//     .then((response) => {
//       setPitInventoryDetails(response.data);
//       const tempArr = []
//       response.data?.map((item) => {
//             tempArr.push({
//                   "surprise": '',
//                   "checkstatus": 0,
//                   "inspector_name": '',
//                   "date_of_inspection": '',
//                   "quality_parameter": '',
//                   "bundleId":item.bundleId
//               });
//         });
//         setTempArrPit(tempArr);     
//       setLoading(false)
//     })
//     .catch(function (error) {
//       console.log("apiClientERROR", error);

//     });
// }

// export function getpitinventorydetails(inspectionFor, materialCode, setPitInventoryDetails) {
//   loaderService.showLoader();
//   apiClient
//     .post(FETCH_PIT_INVENTORY_DETAILS,
//       {
//         "materialCode": materialCode,
//         "stakeholderType": inspectionFor
//       },
//       {
//         headers: {
//           Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
//         }
//       }, null
//     )
//     .then((response) => {
//       setPitInventoryDetails(response.data);
//       loaderService.hideLoader();
//     })
//     .catch(function (error) {
//       console.log("apiClientERROR", error);
//       loaderService.hideLoader();
//     });
// }

export function getpitinventorydetails(stakeholderUrn, setPitInventoryDetails) {
  loaderService.showLoader();
  apiClient
    .post(INSPECTION_FETCH_BUNDLEID_DETAILS,
      {
        "stakeholderUrn": stakeholderUrn
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      setPitInventoryDetails(response.data);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}

export function searchbyURN(inspectionFor, materialCode, setGetUrnList) {
  loaderService.showLoader();
  apiClient
    .post(INSPECTION_FETCH_PITDETAILS,
      {
        "materialCode": materialCode,
        "stakeholderType": inspectionFor
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      setGetUrnList(response.data);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}


export function fetchmanagetolerancelist(setAllToleranceLists) {
  loaderService.showLoader();
  apiClient
    .post(FETCH_MANAGE_TOLERANCE_LIST,
      {

      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      setAllToleranceLists(response.data.qualityManagedToleranceLimitList);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}

export function addmanagetolerancelist(details, setAddToleranceLists, operation) {
  loaderService.showLoader();
  apiClient
    .post(ADD_MANAGE_TOLERANCE_LIST,
      {
        "id": details?.id ? details?.id : null,
        "qualityParameter": details?.QualityparameterText ? details?.QualityparameterText : details?.qualityParameter,
        "materialCode": details?.materialCode,
        "toleranceLimit": details?.toleranceLimit,
        "unitOfMeasurement": details?.unitOfMeasurement,
        "minValue": details.minValue,
        "maxValue": details?.maxValue,
        "crtdBy": details?.crtdBy ? details?.crtdBy : null,
        "createdOn": details?.createdOn ? details?.createdOn : null,
        "updatedOn": details?.updatedOn ? details?.updatedOn : null,
        "updtdBy": details?.updtdBy ? details?.updtdBy : null,
        "validFrom": details?.validFrom ? details?.validFrom : null,
        "validTo": details?.validTo ? details?.validTo : null,
        "operartion": operation
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      setAddToleranceLists(response.data);
      if (response.data.status === 'FAILURE') {
        toast.error(response.data.description)
      }
      else {
        toast.success(response.data.description)
      }
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}

export function deletemanagetolerancelist(deleteid, setDeleteToleranceLists) {
  loaderService.showLoader();
  apiClient
    .post(DELETE_MANAGE_TOLERANCE_LIST,
      {
        "requestId": deleteid
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      setDeleteToleranceLists(response.data);
      toast.success(response.data.description)
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}

export function ByIdFetchmanagetolerance(fetchid, setFetchByIdToleranceLists) {
  loaderService.showLoader();
  apiClient
    .post(FETCH_MANAGE_TOLERANCE_LIST_BY_ID,
      {
        "requestId": fetchid
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      setFetchByIdToleranceLists(response.data);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}

export function Editmanagetolerance(fetchbyidtolerancelists, details, id, setEditToleranceLists) {
  loaderService.showLoader();
  apiClient
    .post(EDIT_MANAGE_TOLERANCE_LIST,
      {
        "id": id,
        "qualityParameter": details?.QualityparameterText ? details?.QualityparameterText : details?.qualityParameter ? details.qualityParameter : fetchbyidtolerancelists.qualityParameter,
        "materialCode": details?.materialCode ? details?.materialCode : fetchbyidtolerancelists.materialCode,
        "toleranceLimit": (details?.minValue || details?.maxValue) ? '' : details?.toleranceLimit ? details?.toleranceLimit : fetchbyidtolerancelists.toleranceLimit,
        "unitOfMeasurement": details?.unitOfMeasurement ? details?.unitOfMeasurement : fetchbyidtolerancelists.unitOfMeasurement,
        "crtdBy": fetchbyidtolerancelists?.crtdBy ? fetchbyidtolerancelists?.crtdBy : '',
        "minValue": details?.toleranceLimit ? '' : details?.minValue ? details?.minValue : fetchbyidtolerancelists.minValue,
        "maxValue": details?.toleranceLimit ? '' : details?.maxValue ? details?.maxValue : fetchbyidtolerancelists.maxValue
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      setEditToleranceLists(response.data);
      toast.success(response.data.description)
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}

export function getAllIssue() {
  return new Promise((resolve, reject) => {
    loaderService.showLoader();
    apiClient
      .post(GET_ISSUE_LIST,
        {},
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      ).then((response) => {
        resolve(response.data);
        loaderService.hideLoader();
        // getAllIssues(response.data);
        // console.log(getAllIssues, "responsePP")
      }).catch(function (error) {
        console.log(error, "errorReport")
        reject(error)
        loaderService.hideLoader();
      })
  })
}

export function userDetail(issueNumber) {
  return new Promise((resolve, reject) => {
    apiClient.post(FETCH_ISSUE_FROM_ISSUE_NUMBER + issueNumber,
      {},
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    ).then((response) => {
      // getIssueDetails(response.data);
      resolve(response.data);
      // console.log(getIssueDetails, "updateResponse")
    }).catch(function (error) {
      console.log(error, "errorReport")
      reject(error)
    })
  })
}

export function updateIssue(getIssueById, getUpdateIssueById) {
  return new Promise((resolve, reject) => {
    apiClient.post(UPDATE_ISSUE_BY_ID,
      getIssueById,
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    ).then((response) => {
      getUpdateIssueById(response.data);
      resolve(response.data);
    }).catch(function (error) {
      console.log(error, "errorReport")
    })
  })
}

export function saveinspectiondetails(createWorkOrderReqst, setFinalInspectionSubmission, navigate) {
  loaderService.showLoader();
  apiClient
    .post(ADD_CREATE_INSPECTION,
      // "createWorkOrderReqst": createWorkOrderReqst
      ...createWorkOrderReqst
      ,
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      setFinalInspectionSubmission(response.data);
      if (response.data.status === 'FAILURE') {
        toast.error(response.data.description)
        navigate(`../inspectionworkorder/`)
      }
      else {
        toast.success(response.data.description);
        navigate(`../inspectionworkorder/`);
      }

      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}

export function fetchinspectordetails(setInspectorDetails) {
  apiClient
    .post(FETCH_INSPECTOR_LIST,
      {

      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      setInspectorDetails(response.data);
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);

    });
}

export function fetchqualitydetails(setQualityParamDetails) {
  loaderService.showLoader();
  apiClient
    .post(FETCH_QUALITY_PARAMETER_LIST,
      {

      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      setQualityParamDetails(response.data);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}


export function fetchequipmentdetailsdetails(setAllEquipmentDetails) {
  loaderService.showLoader();
  apiClient
    .post(FETCH_EQUIPMENT_LIST,
      {

      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      setAllEquipmentDetails(response.data);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}

export function fetcheditableinspection(id, setFetchInspectionDetails) {
  loaderService.showLoader();
  apiClient
    .post(FETCH_INSPECTION_DETAILS_BY_ID,
      {
        // "requestId": id
        "inpsectionOrderId": id

      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      setFetchInspectionDetails(response.data.qualityInspectionWorkOrderEntity);
      // const quaparamList = response.data;
      // setQuaParamArr(quaparamList?.qualityWorkLogEntity?.map(i => i.qualityParameter));
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}
export function fetchinspectionCategory(setFetchCategoryDetails) {
  loaderService.showLoader();
  apiClient
    .post(FETCH_BY_INSPECTION_CATEGORY,
      {

      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      setFetchCategoryDetails(response.data);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}

export function getStatusList(setStatusList) {
  loaderService.showLoader();
  apiClient
    .post(FETCH_STATUS_DROPDOWN,
      {
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      setStatusList(response.data);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      // toast.error(error.message);
      loaderService.hideLoader();
    });
}

export function getQualityParameterList(setQualityParameterList) {
  loaderService.showLoader();
  apiClient
    .post(FETCH_QUALITY_PARAMETER_DROPDOWN,
      {
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      setQualityParameterList(response.data);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      // toast.error(error.message);
      loaderService.hideLoader();
    });
}

export function getInspectionDetails(inspectionOrderId, setInspectionDetails, setQualityDocumentMasterEntity, setLabel) {
  loaderService.showLoader();
  apiClient
    .post(FETCH_INSPECTION_DETAILS_BY_ID,
      {
        "inpsectionOrderId": inspectionOrderId
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      setInspectionDetails(response.data.qualityInspectionWorkOrderEntity);
      setLabel(bundleArr.find((item) => item.code === (response?.data?.qualityInspectionWorkOrderEntity?.bundleIdEntity[0]?.bundleId)?.slice(0, 3))?.name)
      setQualityDocumentMasterEntity(response.data.qualityDocumentMasterEntity)
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      // toast.error(error.message);
      loaderService.hideLoader();
    });
}

export function editInspectionList(id, details, fetchdetails, checkstatus, qualityWorkLogEntity, setFinalEditInspection, navigate) {
  loaderService.showLoader();
  apiClient
    .post(EDIT_INSPECTION_DETAILS_BY_ID,
      {
        "id": fetchdetails?.id,
        "inspectionOrderId": fetchdetails?.inspectionorderId,
        "inspectDescription": details?.inspectDescription ? details?.inspectDescription : fetchdetails?.inspectDescription,
        "categoryOfInspection": details?.categoryOfInspection ? details?.categoryOfInspection : fetchdetails?.categoryOfInspection,
        "requesterName": fetchdetails?.requesterName,
        "inspectorName": details?.inspectorName ? details?.inspectorName : fetchdetails?.inspectorName,
        "inspectorEmail": details?.inspectorEmail ? details?.inspectorEmail : fetchdetails?.inspectorEmail,
        "inspectorContactNo": details?.inspectorContact ? details?.inspectorContact : fetchdetails?.inspectorContact,
        "materialCode": details?.materialCode ? details?.materialCode : fetchdetails?.materialCode,
        "inspectionEquipmentUsed": details?.inspectionEquipmentUsed ? details?.inspectionEquipmentUsed : fetchdetails?.inspectionEquipmentUsed,
        "createdDate": fetchdetails?.createdDate,
        "status": details?.status ? details?.status : fetchdetails?.status,
        "measuredQuantity": fetchdetails?.measuredQuantity,
        "actualQuantity": fetchdetails?.actualQuantity,
        "dateOfInspection": details?.dateOfInspection ? details?.dateOfInspection : fetchdetails?.dateOfInspection,
        "inspectionLocationType": details?.inspectionLocationType ? details?.inspectionLocationType : fetchdetails?.inspectionLocationType,
        "inspectionStorageLocation": details?.inspectionStorageLocation ? details?.inspectionStorageLocation : fetchdetails?.inspectionStorageLocation,
        "lotNumber": details?.lotNumber ? details?.lotNumber : fetchdetails?.lotNumber,
        "triggeringReason": details?.triggeringReason ? details?.triggeringReason : fetchdetails?.triggeringReason,
        "grievenceNumber": fetchdetails?.grievenceNumber,
        "isActive": 1,
        "surprise": checkstatus ? checkstatus : '',
        "createdBy": fetchdetails?.createdBy,
        "createdOn": fetchdetails?.createdOn,
        "bundleIdEntity": qualityWorkLogEntity
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      setFinalEditInspection(response.data);
      if (response.data.status === 'FAILURE') {
        toast.error(response.data.description);
        navigate(`../inspectionworkorder/`)
      }
      else {
        toast.success(response.data.description)
        navigate(`../inspectionworkorder/`)
      }
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}

export function actionInspectionList(inspectionAssignDetails, closestatus, quaParaArray, setSelectedInspectorDetails, navigate) {
  loaderService.showLoader();
  apiClient
    .post(EDIT_INSPECTION_DETAILS_BY_ID,
      {
        "id": inspectionAssignDetails?.id,
        "inspectionOrderId": inspectionAssignDetails?.orderId,
        "inspectDescription": inspectionAssignDetails?.inspectDescription,
        "categoryOfInspection": inspectionAssignDetails?.categoryOfInspection,
        "requesterName": inspectionAssignDetails?.requesterName,
        "inspectorName": inspectionAssignDetails?.inspectorName,
        "inspectorEmail": inspectionAssignDetails?.inspectorEmail,
        "inspectorContactNo": inspectionAssignDetails?.inspectorContact,
        "materialCode": inspectionAssignDetails?.materialCode,
        "inspectionEquipmentUsed": inspectionAssignDetails?.inspectionEquipmentUsed,
        "createdDate": inspectionAssignDetails?.createdDate,
        "status": closestatus === 'Closed' ? closestatus : inspectionAssignDetails?.status,
        "measuredQuantity": inspectionAssignDetails?.measuredQuantity,
        "actualQuantity": inspectionAssignDetails?.actualQuantity,
        "dateOfInspection": inspectionAssignDetails?.dateOfInspection,
        "inspectionLocationType": inspectionAssignDetails?.locationType,
        "inspectionStorageLocation": inspectionAssignDetails?.storageLocation,
        "lotNumber": inspectionAssignDetails?.lotNumber,
        "triggeringReason": inspectionAssignDetails?.triggeringReason,
        "grievenceNumber": inspectionAssignDetails?.grievenceNumber,
        "surprise": inspectionAssignDetails?.surprise,
        "createdBy": inspectionAssignDetails?.createdBy,
        "createdOn": inspectionAssignDetails?.createdOn,
        "bundleIdEntity": quaParaArray
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      setSelectedInspectorDetails(response.data);
      if (response.data.status === 'FAILURE') {
        toast.error(response.data.description);
        navigate(`../inspectionworkorder/`)
      }
      else {
        toast.success(response.data.description)
        navigate(`../inspectionworkorder/`)
      }
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}


export function createIssue(bundleIdArr) {
  loaderService.showLoader();
  apiClient
    .post(CREATE_ISSUE,
      bundleIdArr,
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      // toast.error(error.message);
      loaderService.hideLoader();
    });
}

export function updateConductInspect(inspectionOrderId, status, submitFlag, bundleIdArr, setUpdateResponse, navigate, qualityDocumentMasterEntity, issueFlag, stakeholderUrn, stakeholderType) {
  loaderService.showLoader();
  apiClient
    .post(UPDATE_CONDUCT_INSPECTION_SUBMIT,
      {
        "inspectionWorkOrderId": inspectionOrderId,
        "status": status,
        "submitFlag": submitFlag,
        "bundleId": bundleIdArr,
        "qualityDocumentMasterEntity": qualityDocumentMasterEntity
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      submitFlag && (!issueFlag ? createIssue(bundleIdArr) : pitInvoiceIssue(bundleIdArr, status, stakeholderUrn, stakeholderType))
      setUpdateResponse(response.data);
      response.data.status === "SUCCESS" ? 
      toast.success(response.data.description) :  toast.error(response.data.description)
      response.data.status === "SUCCESS" && navigate(`../inspectionworkorder`)
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      // toast.error(error.message);
      loaderService.hideLoader();
    });
}

export function updateWorklog(inspectionOrderId, comment, createdOn, id, setWorklogDetails) {
  loaderService.showLoader();
  apiClient
    .post(UPDATE_WORKLOG,
      {
        "inspectionOrderId": inspectionOrderId,
        "comments": comment,
        "createdOn": createdOn
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      fetchWorklog(inspectionOrderId, setWorklogDetails)
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      // toast.error(error.message);
      loaderService.hideLoader();
    });
}

export function fetchTolerance(qualityParameter, materialCode, qualityRows, setQualityRows, selectedId) {
  loaderService.showLoader();
  apiClient
    .post(FETCH_PARA_TOLERANCE_LIMIT,
      {
        "qualityPara": qualityParameter,
        "materialCode": materialCode
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      const tempArr = (qualityRows?.map(item => {
        if (item.qualityParameter === response?.data?.qualityParameter && item?.id === selectedId) {
          item.toleranceLimit = response?.data?.toleranceLimit
          item.minimumLimit = response?.data?.minValue
          item.maximumLimit = response?.data?.maxValue

        }
        return item
      }
      ))
      setQualityRows(tempArr);
      if (response.data.status === "FAILURE") {
        toast.error(response.data.description)
      }
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      // toast.error(error.message);
      loaderService.hideLoader();
    });
}

export function fetchWorklog(inspectionOrderId, setWorklogDetails) {
  loaderService.showLoader();
  apiClient
    .post(FETCH_WORKLOG,
      {
        "inpsectionOrderId": inspectionOrderId
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      const tempArr = []
      response?.data?.map((item, index) => {
        if (item?.comments) {
          tempArr.push({
            // "id": index,
            "comments": item?.comments,
            "updtdBy": item?.updtdBy,
            "updatedOn": item?.updatedOnStr
          });
        }
      })
      setWorklogDetails(tempArr);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      // toast.error(error.message);
      loaderService.hideLoader();
    });
}

export function getInspectorList() {
  return new Promise((resolve, reject) => {
    apiClient.post(GET_ISPECTOR_DETAILS,
      {},
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    ).then((response) => {
      // getInspectorList(response.data);
      resolve(response.data);
    }).catch(function (error) {
      reject(error)
    })
  })
}

export function fetchBundles(bundleId, grevianceDetails, setGreievanceDetails) {
  loaderService.showLoader();
  apiClient
    .post(BUNDLES_BY_CON,
      {
        "bundleId": bundleId,
        "consignmentNo": null
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      setGreievanceDetails({
        ...grevianceDetails, materialCode: response?.data?.bundleDetailsList[0]?.materialType,
        weightactualQuantity: response?.data?.bundleDetailsList[0]?.weight,
        mositureactualQuantity: response?.data?.bundleDetailsList[0]?.mositure
      })
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      // toast.error(error.message);
      loaderService.hideLoader();
    });
}

export function getDocumentUploadDetails(file, qualityDocumentMasterEntity, setQualityDocumentMasterEntity, selectedItemForAttachment) {
  loaderService.showLoader();
  const formData = new FormData();
  formData.append("file", file);
  formData.append("fileName", file.name);
  formData.append("containerName", "qualityfiles");
  apiClient
    .post(
      UPLOAD_DCUMENT,
      formData,
      {
        headers: {
          AuthKey: authKey,
        },
      }
    )
    .then((response) => {
      response?.data?.isSuccess === true ? toast.success(response?.data?.message) : toast.error(response?.data?.message);
      if (response?.data?.isSuccess === true) {
        const blobResponse = response?.data?.blobResponse
        const tempArr = [...qualityDocumentMasterEntity]
        // selectedFiles?.map((item) => {
        tempArr.push({
          documentName: blobResponse?.fileName,
          documentBlobName: blobResponse?.blobFileName,
          documentContainerName: "qualityfiles",
          isActive: 1,
          bundleId: selectedItemForAttachment?.bundleId,
          qualityParameter: selectedItemForAttachment?.qualityParameter,
        });
        // });
        setQualityDocumentMasterEntity(tempArr);
      }
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log(error);
      toast.error(error.message);
      loaderService.hideLoader();
    });
}

export const downloadDocument = (file) => {
  loaderService.showLoader()
  return fetch(DOWNLOAD_DOCUMENT,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        AuthKey: authKey,
      },
      body: JSON.stringify({
        "fileName": file?.documentBlobName,
        "containerName": "qualityfiles",
        "file": ""
      })
    })
    .then((response) => response.blob()
    )
    .then((blob) => {
      const fileName = file?.documentName
      const splittedName = fileName.split('.')
      const fileExtension = splittedName[splittedName.length - 1];
      let fileType;
      switch (fileExtension) {
        case 'pdf':
          fileType = 'application/pdf';
          break;
        case 'png':
          fileType = 'image/png';
          break;
        case 'jpg':
          fileType = 'image/jpeg';
          break;
        case 'jpeg':
          fileType = 'image/jpeg';
          break;
        default:
          fileType = 'application/octet-stream';
      }
      const url = window.URL.createObjectURL(new Blob([blob], { type: fileType }));
      const newWindow = window.open(url, '_blank');
      newWindow.focus();
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log(error);
      loaderService.hideLoader()
    });
}

export function inspectionOrderGraphApi(setStatusnameInspectionApi, setStatusCountInspectionApi) {
  apiClient
    .post(INSPECTION_ORDER_GRAPH,
      {},
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      let temparr1 = []
      let temparr2 = []
      response.data.map((item => {
        temparr1.push(item.statusName)
        temparr2.push(item.statusCountPojo.statusCount)
      }))

      setStatusCountInspectionApi(temparr2);
      setStatusnameInspectionApi(temparr1);
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
    });
}

export function issueGraphApi(setStatusnameIssueApi, setStatusCountIssueApi) {
  apiClient
    .post(ISSUE_ATC_ATC,
      {},
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      let tempIssuearr1 = []
      let tempIssuearr2 = []
      response.data.map((item => {
        tempIssuearr1.push(item.statusName)
        tempIssuearr2.push(item.statusCountPojo.statusCount)
      }))

      setStatusnameIssueApi(tempIssuearr1);
      setStatusCountIssueApi(tempIssuearr2);
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
    });
}

export function fetchWorkList(setWorkListDetails) {
  loaderService.showLoader();
  apiClient
    .post(FETCH_WORKLIST,
      {
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      setWorkListDetails(
        response.data?.requestList.map(item => {
          return {
            ...item,
            comment: ""
          };
        }))
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      // toast.error(error.message);
      loaderService.hideLoader();
    });
}

export function toleranceApproval(selectedRows, setWorkListDetails, setSelectedRows, navigate) {
  loaderService.showLoader();
  apiClient
    .post(TOLERANCE_APPROVAL,
      {
        "requestList": selectedRows
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      setSelectedRows([]);
      fetchWorkList(setWorkListDetails);
      if (response.data.status === 'FAILURE') {
        toast.error(response.data.description);
        navigate(`/qualitydashboard/manageWorkList`)
      }
      else {
        toast.success(response.data.description);
        navigate(`/qualitydashboard/manageWorkList`);
      }
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      // toast.error(error.message);
      loaderService.hideLoader();
    });
}

export function pitInvoiceIssue(bundleIdArr, status, urn, type) {
  const pitBundleIdArr = bundleIdArr.map(outerItem => {
      const { id, qualityWorkLogEntity, bundleId, workOrderTableId, ...rest } = outerItem;
 
      const updatedNestedArray = qualityWorkLogEntity.map(innerItem => {
        const { bundleTableId, comments, inspectionOrderId, actualQuantity, materialCode, recordedQuantity, newQuantity, triggeringReason, ...innerRest } = innerItem;
        return {...innerRest, actualValue: actualQuantity, materialType: materialCode, recordedValue: recordedQuantity, postInspectionValue: newQuantity};
      });
 
      return {
        ...rest,
        consignmentNo: bundleId,
        issueNumber: qualityWorkLogEntity[0].triggeringReason,
        qualityParametersList: updatedNestedArray
      };
    });
  apiClient
    .post(PIT_INVOICE_ISSUE,
      {
        "stakeholderType": type,
        "stakeholderUrn": urn,
        "status": status,
        "invoiceIssuesList": pitBundleIdArr
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}